<!-- checkout.component.html -->
<app-terms #termsModal (accept)="acceptedTerms($event)" ></app-terms>
<div class="checkout-container bg-gradient" *ngIf="formInUse">
  <div class="summary-container">
    <!-- Instructions -->
    <div class="h4 instructions" [innerHTML]="uiLabels.instructions"></div>

    <!-- New Customers: Plan Details Section -->
    <div class="h4 instruction" *ngIf="selected">
      <div class="details-header">Plan Details</div>
      <div>{{ uiLabels.type }} {{ selected.title }}</div>
      <div>{{ uiLabels.estimatedUsage }} {{ estimatedUsage }}</div>

      <div class="price-summary-grid">
        <div class="label">{{ uiLabels.planPrice }}</div>
        <div class="value">{{ planPrice | currency:"USD":"symbol":"1.0-0" }}</div>

        <ng-container *ngIf="integrationPrice">
          <div class="label">Integration:</div>
          <div class="value">
            <span class="integration-name">{{ selectedIntegration.name }}</span>&nbsp;&nbsp;+&nbsp;&nbsp;
            {{ integrationPrice | currency:"USD":"symbol":"1.0-0" }}
          </div>

          <div class="label">{{ uiLabels.price }}</div>
          <div class="value">{{ selectedPrice | currency:"USD":"symbol":"1.0-0" }}</div>
        </ng-container>

        <ng-container *ngIf="estimatedTax !== null">
          <div class="label">{{ uiLabels.tax }}</div>
          <div class="value">{{ estimatedTax | currency:"USD":"symbol":"1.0-0" }}</div>
          <div class="label">{{ uiLabels.total }}</div>
          <div class="value">{{ totalPrice | currency:"USD":"symbol":"1.0-0" }}</div>
        </ng-container>
      </div>

      <div>{{ uiLabels.cycle }} {{ billingCycle | titlecase }}</div>
    </div>

    <!-- Existing Customers: Transaction Details Section -->
    <div class="h4 instruction" *ngIf="creditCardInfoStripe">
      <div class="details-header">Transaction Details</div>
      <br>
      <div>{{ uiLabels.purchaseType }} {{ creditCardInfoStripe.purchaseType }}</div>
      <div class="price-summary-grid">
        <div class="label">
          {{ isSubscriptionAccount ? uiLabels.subscriptionCost : uiLabels.costPerUnit }}
        </div>
        <div class="value">
          {{ creditCardInfoStripe.costPerUnit | currency:"USD":"symbol":"1.0-0" }}
        </div>

        <ng-container *ngIf="!isSubscriptionAccount">
          <div class="label">{{ uiLabels.numberOfUnits }}</div>
          <div class="value">{{ creditCardInfoStripe.numberOfUnits }}</div>
        </ng-container>

        <div class="label">{{ uiLabels.subTotal }}</div>
        <div class="value">{{ price | currency:"USD":"symbol":"1.0-0" }}</div>

        <ng-container *ngIf="estimatedTax !== null">
          <div class="label">{{ uiLabels.tax }}</div>
          <div class="value">{{ estimatedTax | currency:"USD":"symbol":"1.0-0" }}</div>
          <div class="label">{{ uiLabels.total }}</div>
          <div class="value">{{ (price + estimatedTax) | currency:"USD":"symbol":"1.0-0" }}</div>
        </ng-container>
      </div>
    </div>

  </div>

  <div class="form-container">
    <div class="card shadow-lg">
      <form [formGroup]="infoFormGroup" (ngSubmit)="onSubmit()">
        <div class="form-sections-container">
          <div *ngFor="let section of formInUse.formSections; let i = index" [@slideAnimation]="slideDirection">
            <div *ngIf="i === currentSection" class="form-section active">
              <h3 *ngIf="section[0].sectionTitle">{{ section[0].sectionTitle }}</h3>
              <div class="input-row">
                <ng-container *ngFor="let input of section">
                  <div *ngIf="!input.isSeparator && shouldDisplay(input.id)" class="input-field" [class.full-width]="input.fullWidth">
                    <app-web-form-field
                      #field
                      [id]="input.id"
                      [field]="input"
                      [control]="getControlAsFormControl(input.id)"
                      (changeEvent)="handleChangeEvent($event)"
                      (keydown)="handleKeyDown($event, input)">
                    </app-web-form-field>
                  </div>
                </ng-container>
              </div>

              <!-- Terms and Conditions Checkbox -->
              <div *ngIf="i === formInUse.formSections.length - 1; else elseBlock" class="terms-checkbox">
                <label for="terms">
                  <input
                    #termsCheckbox
                    id="terms"
                    type="checkbox"
                    name="terms"
                    formControlName="termsAccepted"
                    (keydown)="handleKeyDown($event, termsCheckbox)"
                  />
                  <span>
                    I have read and agree to the
                    <a href="javascript:void(0)" (click)="openTermsModal($event)">Online Testing agreement terms</a>.
                    <span>*</span>
                  </span>
                </label>

                <div class="form-input-label field-validation abs-field"
                     *ngIf="infoFormGroup.get('termsAccepted').invalid &&
                            (infoFormGroup.get('termsAccepted').dirty || infoFormGroup.get('termsAccepted').touched)">
                  Please accept the terms to proceed.
                </div>
              </div>
              <ng-template #elseBlock>
                <div class="terms-checkbox-placeholder terms-checkbox">
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <!-- Navigation Buttons -->
        <div class="button-row">
          <div class="button-container">
            <app-web-button
              *ngIf="!isDirectEntry"
              [id]="'checkout-back'"
              [label]="uiLabels.backBtn"
              [data]="uiLabels.backBtn"
              [style]="'white'"
              (clicked)="onBack()">
            </app-web-button>
            <app-web-button
              #submitButton
              [id]="'checkout-submit'"
              [label]="getSubmitButtonLabel()"
              [data]="getSubmitButtonLabel()"
              [style]="'white'"
              [disabled]="!isSectionValid()"
              (clicked)="onSubmit()"
              tabindex="0">
            </app-web-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
